// Import the functions you need from the SDKs you need
import { initializeApp, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDBKGtwC_fFfpid07l58ZcbnTzN7Fs8-0Y",
  authDomain: "neo-qcr.firebaseapp.com",
  projectId: "neo-qcr",
  storageBucket: "neo-qcr.firebasestorage.app",
  messagingSenderId: "457505557849",
  appId: "1:457505557849:web:f9a9ffd9e81d326be61048",
  measurementId: "G-4LN66EHBFE"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const getFirebaseAuth = () => getAuth(getApp());
export const auth = getAuth(app);
